module.exports = __webpack_public_path__ + "img/Bodice-Front-B11-Da-Eb.6c87b257.png";